import { useAppHandlingContext } from '../contexts/app-handling.context';
export function useAppParams() {
    const { params, setParams, availableBlockchains } = useAppHandlingContext();
    return Object.assign(Object.assign({}, params), { setParams, availableBlockchains });
}
